/**
 * Tools and data relating to location
 *
 * @module features/Location
 */
export { PhysicalAddress } from './PhysicalAddress.js';
export { PhysicalAddress as Address } from './PhysicalAddress.jsx';
export { VenueLocation } from './VenueLocation.js';
